import type { EventParticipant, EventsParticipant } from "mws-ts-v2-sdk";

export type EventNameDetails = {
  name: string;
  forceEventName: boolean;
  participants: EventsParticipant[] | EventParticipant[];
};

export enum EventListDisplayType {
  CardLarge = "cardLarge",
  CardSmall = "cardSmall",
  Slider = "slider",
}
